<template>
  <div
    :id="'bookpage_' + pageNumber"
    :class="`content flex-column justify-center bookpage ${visible ? 'current-page' : ''}`"
    :style="{ display: visible ? 'flex' : 'none' }"
    v-html="content"
  >
  </div>
</template>

<script>
export default {
  name: 'Pages',
  props: {
    pageNumber: {
      type: [String, Number],
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: {},
    },
  },
}
</script>
